import { createSlice } from "@reduxjs/toolkit";
import { isBoolean } from "../../../utils/utils";

const commonSlice = createSlice({
  name: "commonInfo",
  initialState: {
    signUpModalOpen: false,
    affiliateRef: null,
    autoPlay: isBoolean(JSON.parse(localStorage.getItem("autoPlay")))
      ? JSON.parse(localStorage.getItem("autoPlay"))
      : true,

    isModalOpened: false,
  },
  reducers: {
    setSignUpModalOpen: (state, action) => {
      state.signUpModalOpen = action.payload;
    },
    setAutoPlay: (state, action) => {
      state.autoPlay = action.payload;
      localStorage.setItem("autoPlay", JSON.stringify(action.payload));
    },
    setAffiliateRef: (state, action) => {
      state.affiliateRef = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  setSignUpModalOpen,
  setAffiliateRef,
  setIsModalOpened,
  setAutoPlay,
} = commonSlice.actions;

export const selectSignUpModalOpen = (state) =>
  state.commonInfo.signUpModalOpen;
export const selectAffiliateRef = (state) => state.commonInfo.affiliateRef;
// export const selectAutoPlay = (state) => state.commonInfo.autoPlay;

export const selectAutoPlay = (state) => {
  const { autoPlay } = state.commonInfo;
  const { loggedIn } = state.authInfo;
  return loggedIn ? autoPlay : true;
};

export default commonSlice.reducer;
